// extracted by mini-css-extract-plugin
module.exports = {"guides":"guides-module--guides--eM-Lu","title":"guides-module--title--3-PJ4","guide":"guides-module--guide--2Vh-J"};